// @flow

import { createAction } from 'redux-actions';
import { SET_LANDING_TAB, SET_LANDING_TAB_IN_SAME_BROWSER } from './constants';

// eslint-disable-next-line
export const setLandingTab = createAction(
    SET_LANDING_TAB, (isLandingTab: boolean | null) => ({ isLandingTab }),
);

export const setLandingTabInSameBrowser = createAction(
    SET_LANDING_TAB_IN_SAME_BROWSER, (isLandingTabInSameBrowser: boolean) => ({ isLandingTabInSameBrowser }),
);
